import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Container,
    Col,
    Toast,
    ToastBody,
    ToastHeader
} from "reactstrap";
import { FaUserSlash, FaEye } from 'react-icons/fa';
import EditUserModal from "../Modals/EditUserModal.js";
import NewAdminModal from "../Modals/NewAdminModal.js";

const ROLE_LABELS = {
    1: "Super Admin",
    2: "Administrateur",
    3: "Manager",
    4: "Créateur",
    5: "Utilisateur",
};

const ROLE_BADGES = {
    1: "danger",      // Super Admin
    2: "warning",     // Administrateur
    3: "primary",     // Manager
    4: "info",        // Créateur
    5: "secondary",   // Utilisateur
};



const GestionAdmin = () => {
    const [users, setUsers] = useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [isEditOpen, setIsEditOpen] = useState(false);

    const getRoleLabel = (user_ROLE_ID) =>
        ROLE_LABELS[Number(user_ROLE_ID)] || "Rôle inconnu";

    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [showErrorToast, setShowErrorToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const showSuccess = (message) => {
        setShowErrorToast(false);
        setToastMessage(message);
        setShowSuccessToast(true);
        setTimeout(() => setShowSuccessToast(false), 3000);
    };

    const showError = (message) => {
        setShowSuccessToast(false);
        setToastMessage(message);
        setShowErrorToast(true);
        setTimeout(() => setShowErrorToast(false), 3000);
    };


    // Charger la liste des users
    const fetchUsers = () => {
        axios.get("/api/user/list", { withCredentials: true })
            .then(res => setUsers(Array.isArray(res) ? res : []))
            .catch(err => console.error(err));
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    // Supprimer un utilisateur
    const handleDelete = (id) => {
        if (!window.confirm("Voulez-vous vraiment supprimer cet utilisateur ?")) return;

        axios.delete(`/api/user/delete/${id}`, { withCredentials: true })
            .then(() => {
                // Retirer l'utilisateur supprimé du state
                setUsers(prev => prev.filter(user => user.user_ID !== id));
                showSuccess("Utilisateur supprimé avec succès !");
            })
            .catch(err => {
                console.error(err);
                showError("Erreur lors de la suppression de l'utilisateur");
            });
    };

    const handleOpenDashboard = (id) => () => { };

    const handleEditUser = (user) => setEditingUser(user);

    const handleResetPassword = async (email) => {
        try {
            const newPassword = prompt("Entrez le nouveau mot de passe pour l'utilisateur :");
            if (!newPassword) return;

            const res = await fetch('/api/user/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'include',
                body: JSON.stringify({ user_EMAIL: email, newPassword })
            });

            if (!res.ok) {
                const data = await res.json();
                throw new Error(data.message || 'Erreur lors de la réinitialisation');
            }

            showSuccess("Mot de passe réinitialisé avec succès !");
        } catch (err) {
            console.error(err);
            showError(err.message || "Erreur lors de la réinitialisation du mot de passe");
        }
    };


    const handleUserCreated = () => {
        fetchUsers();
        showSuccess("Utilisateur créé avec succès !");
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Col lg={12}>
                        <div className="card">
                            <div className="card-body">
                                <h1 className='text-primary text-center'>Administrateurs</h1>
                                <h2 className="text-tertiary mb-4 text-center">
                                    Gestion des comptes
                                </h2>
                                {/* Information contextuelle selon le rôle */}
                                <p className="text-secondary mb-2 text-center">
                                    ℹ️ Gérez les administrateurs de votre organisation.
                                </p>

                                <div className="card">
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table table-centered table-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Nom</th>
                                                        <th scope="col">Prénom</th>
                                                        <th scope="col">Email</th>
                                                        <th scope="col">Rôle</th>
                                                        <th scope="col" style={{ width: "50px" }}>Actions</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {Array.isArray(users) && users.length > 0 ? (
                                                        users
                                                            .filter(user => Number(user.user_ROLE_ID) === 2)
                                                            .map(user => (

                                                                <tr key={user.user_ID}>
                                                                    <td>{user.user_SURNAME}</td>
                                                                    <td>{user.user_NAME}</td>
                                                                    <td>
                                                                        <button
                                                                            onClick={handleOpenDashboard(user.user_ID)}
                                                                            className="text-primary p-0 m-0 bg-transparent border-0 ms-1">
                                                                            {user.user_EMAIL}
                                                                        </button>
                                                                    </td>
                                                                    <td>
                                                                        <span className={`badge bg-${ROLE_BADGES[Number(user.user_ROLE_ID)] || "dark"}`}>
                                                                            {getRoleLabel(user.user_ROLE_ID)}
                                                                        </span>
                                                                    </td>
                                                                    <td >
                                                                        <button
                                                                            title="Modifier l'utilisateur"
                                                                            className="btn btn-sm btn-outline-secondary fs-4 py-0 px-1 me-2"
                                                                            onClick={() => {
                                                                                setEditingUser(user);
                                                                                setIsEditOpen(true);
                                                                            }}
                                                                        >
                                                                            <i className="mdi mdi-account-edit"></i>
                                                                        </button>
                                                                        <button
                                                                            title="Réinitialiser le mot de passe"
                                                                            onClick={() => handleResetPassword(user.user_EMAIL)}
                                                                            className="btn btn-sm btn-outline-warning fs-4 py-0 px-1 me-2"
                                                                        >
                                                                            <i className="mdi mdi-key"></i>
                                                                        </button>
                                                                        <button
                                                                            title="Supprimer cet utilisateur"
                                                                            className="btn btn-sm btn-outline-danger fs-4 py-0 px-1 me-2"
                                                                            onClick={() => handleDelete(user.user_ID)}
                                                                        >
                                                                            <i className="mdi mdi-account-off"></i>
                                                                        </button>
                                                                    </td>

                                                                </tr>
                                                            ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center text-muted">
                                                                Aucun utilisateur
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3 mt-4 d-flex justify-content-center">
                                    <NewAdminModal onUserCreated={handleUserCreated} />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Container>
            </div>
            <EditUserModal
                isOpen={isEditOpen}
                toggle={() => setIsEditOpen(false)}
                user={editingUser}
                onSaved={() => {
                    fetchUsers();
                    showSuccess("Administrateur modifié avec succès");
                }}
            />
            {/* Toast de succès */}
            <div
                style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    zIndex: 9999,
                }}
            >
                <Toast isOpen={showSuccessToast}>
                    <ToastHeader
                        icon="success"
                        toggle={() => setShowSuccessToast(false)}
                        style={{ backgroundColor: '#d4edda', color: '#155724' }}
                    >
                        Succès
                    </ToastHeader>
                    <ToastBody style={{ backgroundColor: '#d4edda', color: '#155724' }}>
                        {toastMessage}
                    </ToastBody>
                </Toast>
            </div>

            {/* Toast d'erreur */}
            <div
                style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    zIndex: 9999,
                }}
            >
                <Toast isOpen={showErrorToast}>
                    <ToastHeader
                        icon="danger"
                        toggle={() => setShowErrorToast(false)}
                        style={{ backgroundColor: '#f8d7da', color: '#721c24' }}
                    >
                        Erreur
                    </ToastHeader>
                    <ToastBody style={{ backgroundColor: '#f8d7da', color: '#721c24' }}>
                        {toastMessage}
                    </ToastBody>
                </Toast>
            </div>
        </React.Fragment>

    );
};

export default GestionAdmin;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license